import { Model } from 'shared/services/api/models/Model'
import { OrderDiscountV1 } from './ordersResponseTypes'

export class OrderDiscount extends Model {
  public readonly affectedProductIds: string[]
  public readonly amount: number
  public readonly displayName: string
  public readonly discountId: string

  constructor(src: OrderDiscountV1) {
    super(src)
    this.affectedProductIds = src.affectedProductIds
    this.amount = src.amount
    this.displayName = src.displayName
    this.discountId = src.discountId
  }
}
